/**
 * Göttfert's ticket types
 */
export default [
  {
    key: 'technical_issue',
    value: 'Technical issue',
    icon: 'alert-square',
    deviceInput: true,
    deviceIdentify: true,
    softwareInput: true,
  },
  {
    key: 'software_support',
    value: 'Software support',
    icon: 'terminal',
    deviceInput: true,
    deviceIdentify: true,
    softwareInput: true,
  },
  {
    key: 'field_service',
    value: 'Field service',
    icon: 'tool',
    deviceInput: true,
    deviceIdentify: true,
    fieldServiceInput: true,
  },
  {
    key: 'clarification_spare_parts',
    value: 'Spare part',
    icon: 'part',
    deviceInput: true,
    deviceIdentify: true,
  },
]
